import { error as logError } from "../utils/logger";

// Prefer env if provided; otherwise use current origin (works for flowman.app and onrender.com)

const API_BASE_URL = "" + (process.env.REACT_APP_API_BASE_URL || window.location.origin);
const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL || API_BASE_URL.replace(/^http/, 'ws');
const IDLE_THRESHOLD_MS = 15 * 60 * 1000; // 15 minutes

function isUserActive() {
  try {
    const last = parseInt(localStorage.getItem('flowman:lastActive') || '0', 10);
    if (!last) return false;
    return Date.now() - last < IDLE_THRESHOLD_MS;
  } catch (e) {
    return true; // assume active if storage unavailable
  }
}

const TokenChecker = async (url, options = {}) => {
  try { 
    // Get the access and refresh tokens from storage (prefer persistent)
    const get = (key) => localStorage.getItem(key) || sessionStorage.getItem(key);
    const accessToken = get("accessToken");
    const refreshToken = get("refreshToken");

    // Add Authorization header with the access token
    if (accessToken) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      };
    }

    // Make the API call
    const response = await fetch(`${API_BASE_URL}${url}`, options);

    // If the access token is expired (401 Unauthorized) and user is ACTIVE,
    // silently refresh and retry. If user is IDLE (>= 15m), do not silently
    // refresh – let the app prompt for manual refresh via AuthContext.
    if (response.status === 401 && refreshToken && isUserActive()) {
      const newAccessToken = await refreshAccessToken(refreshToken);
      if (newAccessToken) {
        options.headers = {
          ...options.headers,
          Authorization: `Bearer ${newAccessToken}`,
        };
        const retryResponse = await fetch(`${API_BASE_URL}${url}`, options);
        return retryResponse;
      }
    }

    // Return the original response if no issues with the token
    return response;
  } catch (error) {
    // Avoid noisy logs in production; still useful in dev
    logError("TokenChecker Error:", error.message);
    throw error; // Propagate the error for handling
  }
};

// Helper function to refresh the access token
async function refreshAccessToken(refreshToken) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh: refreshToken }),
    });
    if (!response.ok) return null;

    const data = await response.json();
    const newAccessToken = data.access;

    if (localStorage.getItem("refreshToken") === refreshToken) {
      localStorage.setItem("accessToken", newAccessToken);
    } else if (sessionStorage.getItem("refreshToken") === refreshToken) {
      sessionStorage.setItem("accessToken", newAccessToken);
    } else {
      localStorage.setItem("accessToken", newAccessToken);
    }
    return newAccessToken;
  } catch (e) {
    return null;
  }
}

export default TokenChecker;
export { API_BASE_URL, WS_BASE_URL };
